import { useRef } from 'react'

import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Input } from '@tribeplatform/react-ui-kit/Input'
import { List } from '@tribeplatform/react-ui-kit/Layout'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { useAppSwitcherItems } from './useWorkspaceItems.js'
import { AppSwitcherListItem } from './WorkspaceItem.js'

export function WorkspacesList() {
  const { $t } = useI18n()
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const {
    searchQuery,
    filteredApps,
    setSearchQuery,
    isLoading,
    currentNetwork,
  } = useAppSwitcherItems()

  if (isLoading && filteredApps.length === 0) {
    return (
      <div className="p-2 flex flex-col gap-2">
        <Input
          placeholder={$t({
            defaultMessage: 'Search communities...',
            id: 'AppSwitcher.SearchPlaceholder',
          })}
          value={searchQuery}
          onChange={e => {
            setSearchQuery(e.target.value)
          }}
          onKeyDown={e => e.stopPropagation()}
          leadingAddon={<SvgIcon name="search" />}
          size="compact"
        />
        <div className="p-4 text-center">
          <Text variant="bodyMd" color="subdued">
            <T
              id="AppSwitcher.Loading"
              defaultMessage="Loading communities..."
            />
          </Text>
        </div>
      </div>
    )
  }

  return (
    <div className="p-2 flex flex-col gap-2">
      <Input
        placeholder={$t({
          defaultMessage: 'Search communities...',
          id: 'AppSwitcher.SearchPlaceholder',
        })}
        value={searchQuery}
        onChange={e => {
          setSearchQuery(e.target.value)
        }}
        onKeyDown={e => e.stopPropagation()}
        leadingAddon={<SvgIcon name="search" />}
        size="compact"
      />
      <div ref={scrollContainerRef} className="max-h-[400px] overflow-y-auto">
        {filteredApps.length === 0 ? (
          <div className="p-4 text-center">
            <Text variant="bodyMd" color="subdued">
              <T
                id="AppSwitcher.NoResults"
                defaultMessage="No communities found"
              />
            </Text>
          </div>
        ) : (
          <List className="my-0">
            {filteredApps.map(workspace => (
              <List.Item key={workspace.id} className="py-1">
                <AppSwitcherListItem
                  workspace={workspace}
                  isActive={workspace.id === currentNetwork?.id}
                />
              </List.Item>
            ))}
          </List>
        )}
      </div>
    </div>
  )
}
